import {apiBaseUrl, axiosInstance} from '../common/baseData';

class EsputnikApi {
  /**
   * Подписка на рассылку, вся логика на сервере, в ответе только результат
   * @param email
   * @returns {Promise<{result: 'subscribedNow'|'subscribedEarly'|'error'}|null>}
   */
  async subscribeByEmail(email) {
    let response = await axiosInstance.post(`${apiBaseUrl}esp/subscribeByEmail`, {email: email});
    return response.data ? response.data : null;
  }
}

export default EsputnikApi;